var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 26,
  viewBox: "0 0 26 26"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-336 -240)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13,0A13,13,0,1,1,0,13,13,13,0,0,1,13,0Z",
  transform: "translate(336 240)",
  fill: "#ffc53d"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(340 244)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 9.205,
  cy: 9.205,
  r: 9.205,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9.205,
  cy: 9.205,
  r: 8.205,
  fill: "none"
})))));
export default __webpack_public_path__ + "static/media/open-orders-snapshot.6bc57172.svg";
export { SvgComponent as ReactComponent };